var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var PopoverContent = function (props) {
    var popoverContent = props.selectProps.popoverContent;
    if (popoverContent) {
        return _jsx(PopoverContentContainer, { children: popoverContent }, void 0);
    }
    else {
        return null;
    }
};
var PopoverContentContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0 12px;\n"], ["\n  padding: 0 12px;\n"])));
export default PopoverContent;
var templateObject_1;
